import React from 'react';

import { Text } from '@r-client/shared/ui/core';
import { ClientRender } from '@r-client/shared/util/components';

import { TGetEventsEventDetails } from '../../../../types';
import { getEventHours } from '../../../../utils';
import { EventProperty } from '../../../event-property/event-property';

interface IEventTimeProps {
  event: NonNullable<TGetEventsEventDetails>;
  dataTestId?: string;
}

export const EventTime: React.FC<React.PropsWithChildren<IEventTimeProps>> = ({
  event,
  dataTestId,
}) => {
  if (event.past) {
    return (
      <EventProperty dataTestId={dataTestId}>
        <Text
          as="span"
          color="gray80"
          type={{ lg: 'bodyBig', xs: 'bodySmall' }}
        >
          Past
        </Text>
      </EventProperty>
    );
  }

  if (event.live) {
    return (
      <EventProperty dataTestId={dataTestId}>
        <Text as="span" color="error" type={{ lg: 'bodyBig', xs: 'bodySmall' }}>
          Live now
        </Text>
      </EventProperty>
    );
  }

  if (event.beginAt) {
    return (
      <ClientRender>
        <EventProperty dataTestId={dataTestId}>
          <Text
            as="span"
            color="gray80"
            type={{ lg: 'bodyBig', xs: 'bodySmall' }}
          >
            {getEventHours(event.timezone, event.beginAt, event.endAt)}
          </Text>
        </EventProperty>
      </ClientRender>
    );
  }

  return null;
};
